module.exports = __webpack_public_path__ + "img/aw.f159ec16.svg";